import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import useMode from "../../../Hooks/useMode";
import "./Service.css";
const services = [
  {
    id: 1,
    icon: "fa-solid fa-pen-nib",
    serviceName: "Web Design",
    details: "Focused on crafting user‑friendly Design and experiences.",
    slide: "fade-right",
  },
  {
    id: 2,
    icon: "fa-solid fa-code",
    serviceName: "Web Development",
    details:
      "I am passionate about building excellent web software that improves the lives of those around me.",
    slide: "fade-up",
  },
  {
    id: 3,
    icon: "fa-solid fa-tablet-screen-button",
    serviceName: "Mobile Apps",
    details:
      " Mainly focused on React Native. I love to build smooth and beautiful mobile apps that solves real-world problems!",
    slide: "fade-left",
  },
];
const Service = () => {
  const { theme } = useMode();
  return (
    <div
      className={`${
        theme === "light" ? "service-container-light" : "service-container-dark"
      } service-container text-light`}
    >
      <div data-aos="fade-up" className="text-center mb-5">
        <p className="txt">SERVICES</p>
        <h3
          className={`${
            theme === "light" ? "text-dark" : "text-light"
          } text fw-bold`}
        >
          What I Do
        </h3>
      </div>
      <Container>
        <Row className="g-4 text-center">
          {services.map((service) => (
            <Col sm={12} md={4} key={service.id} data-aos={service.slide}>
              <div
                className={`${
                  theme === "light" ? "custom-card-light" : "custom-card-dark"
                } custom-card`}
              >
                <h2 className="servie-icon">
                  <i className={service.icon}></i>
                </h2>
                <h4>{service.serviceName}</h4>
                <p>{service.details}</p>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default Service;
